export enum UserStatus {
    RequiresPasswordChange,
    RequiresEmailConfirmation,
    RequiresUserSettingsChange,
    Good,
}
